import type { LandingStrings } from './en';

export const nl: LandingStrings = {
  header: {
    brandSubtitle: 'Toverwinkel',
    contact: 'Contact',
    about: 'Over het spel',
    language: 'Taal',
  },
  footer: {
    terms: 'Gebruiksvoorwaarden',
    privacy: 'Privacybeleid',
    copyright: '{year} {holder}. Alle rechten voorbehouden.',
  },
  home: {
    heroTitle: 'Een gezellig 3D-spel over toverdrankjes en een magische winkel.',
    heroDescription:
      'Zoek ingrediënten tussen de magische rommel, brouw drankjes in de ketel en verkoop ze in je eigen winkel.',
    features: [
      {
        title: 'Je eigen flesje',
        desc: 'Vorm, dop en kleur van het drankje — mooie flesjes brengen meer op.',
      },
      {
        title: 'Brouwen dat ertoe doet',
        desc: 'Elk drankje heeft een eigen recept, en veel ervan werken echt in het spel.',
      },
      {
        title: 'Een verhaal dat je wilt volgen',
        desc: 'Oma is op vakantie en heeft haar winkel aan jou toevertrouwd, en een kikker die Moren heet eist wat hem toekomt.',
      },
      {
        title: 'Een winkel die echt van jou is',
        desc: 'Alleen wat je zelf hebt gebrouwen, wordt verkocht.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: 'Komt binnenkort',
    tags: { search: 'Zoeken op schaduw', craft: 'Drankjes brouwen in 3D', shop: 'Gezellige winkel' },
  },
  about: {
    title: 'Over Qevryno',
    intro: [
      'Welkom bij Qevryno — een gezellig spel over het brouwen van toverdrankjes, waarin magie handwerk is.',
      'Oma is op vakantie gegaan en heeft je gevraagd om op haar geheimzinnige oude huis te passen: vergeten recepten, magische ingrediënten en een ketel die het borrelen nog niet verleerd is. Beneden zit een winkeltje, en het hele dorp vraagt zich al af wie er nu op past.',
      'Brouw drankjes, zorg voor je pluizige magische kat, verkoop je creaties aan charmante klanten en verdien munten om je huis vol magie in te richten — in je eigen tempo, zonder timers.',
    ],
    whatTitle: 'Wat voor spel is het?',
    what: [
      'Qevryno is een ontspannend 3D-puzzelspel dat zoeken naar verborgen voorwerpen, crafting met alchemie en een kleine winkelsimulator combineert. Hou je van gezellige games (cozy games), casual puzzelspellen, zoek-en-vindspellen of spellen over toverdrankjes, alchemie en een eigen magisch winkeltje? Dan is dit jouw spel.',
      'Het is een singleplayerspel dat offline werkt; internet heb je alleen nodig voor aankopen en optionele beloningsvideo’s. Geen banners en geen pop-upadvertenties: een korte video van Google AdMob speelt alleen af als jij erop tikt voor een bonus. Optionele aankopen: edelstenen en ingrediëntenpakketten met zichtbare inhoud. Binnenkort op iOS en Android, in het Nederlands, Engels, Russisch, Spaans, Duits, Frans, Italiaans, Portugees (Brazilië), Pools, Japans, Koreaans, Traditioneel Chinees en Turks.',
    ],
    doTitle: 'Wat je gaat doen',
    doList: [
      'Verborgen ingrediënten zoeken op magische open plekken in een 3D-bos — elke plek is een klein diorama.',
      'Magische recepten brouwen in de ketel: een stabilisator, een hoofdingrediënt, tijdkruiden en een vleugje kleur.',
      'Je eigen flesjes ontwerpen — vorm, dop en kleur van het drankje; mooie flesjes brengen meer op.',
      'Je eigen winkel runnen: klanten, reputatie, jaarmarkten en opdrachten.',
      'Het verhaal volgen: oma is op vakantie en heeft haar winkel aan jou toevertrouwd, en een kikker die Moren heet blijft eisen wat hem toekomt.',
      'Je vondsten fijnwrijven in de vijzel, mengen in de kom en er glitter bij doen — elk mengsel heeft een eigen textuur en kleur.',
      'Je magische kat voeren en je winkel inrichten.',
    ],
    faqTitle: 'Veelgestelde vragen',
    faq: [
      { q: 'Is Qevryno gratis?', a: 'Ja. Het spel is gratis en je kunt het spelen zonder te betalen. Optionele aankopen: edelstenen en ingrediëntenpakketten.' },
      { q: 'Werkt het offline?', a: 'Ja. Het spel zelf heeft geen verbinding nodig — brouw drankjes in het vliegtuig of onder een dekentje. Internet is alleen nodig voor aankopen en optionele beloningsvideo’s.' },
      { q: 'Zijn er advertenties?', a: 'Alleen optionele. Er zijn geen banners en geen pop-upadvertenties tussen schermen. Op een paar plekken kun je, als je wilt, een korte video bekijken en een bonus krijgen, bijvoorbeeld mana. Niets in het spel verplicht je om ze te bekijken. De video’s komen van Google AdMob; meer daarover in het Privacybeleid.' },
      { q: 'Voor welke platforms is het?', a: 'iOS en Android, in het Nederlands, Engels, Russisch, Spaans, Duits, Frans, Italiaans, Portugees (Brazilië), Pools, Japans, Koreaans, Traditioneel Chinees en Turks.' },
      { q: 'Is het eng of stressvol?', a: 'Helemaal niet. Een rustig, gezellig spel: zachte muziek, geen straf voor fouten en een kat met een hoed.' },
    ],
  },
  contact: {
    title: 'Neem contact op',
    subtitle: 'Een vraag over Qevryno, een bug, een aankoop of een advertentie? Stuur ons een e-mail.',
    write: 'E-mail sturen',
    mailSubject: 'Qevryno: ondersteuning',
    tip: 'Vertel welk apparaat je hebt en wat er gebeurde — dan kunnen we je makkelijker helpen.',
    info: {
      title: 'Contactgegevens',
      email: 'E-mail',
      security: 'Beveiliging',
      legalName: 'Ontwikkelaar',
      address: 'Adres',
    },
    refunds: {
      title: 'Terugbetalingen en aankopen',
      description: 'Alle aankopen lopen via de Apple App Store of Google Play. Wil je je geld terug, neem dan contact op met de store:',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/nl-nl/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=nl',
      link: 'Terugbetaling aanvragen',
      note: 'We nemen zelf geen betalingen aan en kunnen geen geld terugbetalen. Is een aankoop niet in het spel aangekomen? Open dan “Instellingen → Aankopen herstellen” of stuur ons een bericht.',
    },
  },
  legal: {
    dataController: 'Verwerkingsverantwoordelijke',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: 'Dit document is alleen beschikbaar in het Engels, Russisch en Spaans. Hieronder staat de Engelse versie.',
  },
};
